import { ValidationErrors, ValidatorFn } from "@angular/forms";

export function loggedInValidator(isUserLoggedIn: boolean): ValidatorFn {
  return (): ValidationErrors | null => {
    if (!isUserLoggedIn) {
      return { notLoggedIn: true };
    }
    return null;
  };
}
